import * as React from 'react';
import { styled } from '@linaria/react';

import { LightWrapper } from '@/components/ColorModeContainer';
import Demo, { DemoSliderControl } from '@/components/Demo';

function ObjectPositionDemo() {
  // const backgroundPosition = React.useMemo(() => {
  //   const frameWidth = 100;
  //   const offset = -(frameIndex * frameWidth);
  //   return `translateX(${offset}px)`;
  // }, [frameIndex]);

  // const foregroundPosition = React.useMemo(() => {
  //   const percentage = (frameIndex / (NUM_FRAMES - 1)) * 100;
  //   return `${percentage}% 0%`;
  // }, [frameIndex]);

  // const includeBriefTransition =
  //   !prefersReducedMotion && frameDuration >= 350;

  return (
    <Demo
      id="sprite-concept-demo"
      outputWrapper={OutputWrapper}
      initialValues={{
        offsetX: 0,
      }}
      controls={[
        <DemoSliderControl
          key="offsetX"
          id="offsetX"
          min={0}
          max={100}
          step={1}
          previewRenderer={(value) => `${value}% 0%`}
          label="object-position"
        />,
      ]}
      customGrid={{
        gridTemplateColumns: 'min(400px, 100%)',
        justifyContent: 'center',
      }}
    >
      {({ offsetX }) => (
        <SpriteViewport>
          <ViewportFrame>
            <BackgroundSprite
              src="/images/sprites/gold-trophy-sprite.webp"
              alt=""
              draggable={false}
              style={{
                transform: `translateX(-${offsetX * 4}px)`,
              }}
            />
            <ForegroundWrapper>
              <ForegroundSprite
                src="/images/sprites/gold-trophy-sprite.webp"
                alt="Current frame of sprite animation"
                draggable={false}
                style={{
                  transform: `translateX(-${offsetX * 4}px)`,
                }}
              />
            </ForegroundWrapper>
          </ViewportFrame>

          <GradientFade />
        </SpriteViewport>
      )}
    </Demo>
  );
}

const OutputWrapper = styled(LightWrapper)`
  overflow: hidden;
  padding-block: 24px;
`;

const SpriteViewport = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  min-height: 120px;
`;

const ViewportFrame = styled.div`
  position: relative;
  width: 104px;
  height: 204px;
`;

const BackgroundSprite = styled.img`
  position: absolute;
  top: 2px;
  left: 2px;
  width: 500px;
  max-width: revert;
  height: 200px;
  opacity: 0.25;
  user-select: none;
`;

const ForegroundWrapper = styled.div`
  position: absolute;
  inset: 0;
  background: var(--color-background);
  outline: 2px solid var(--color-gray-800);
  border: 2px solid var(--color-gray-300);
  border-radius: 2px;
  overflow: hidden;
`;

const ForegroundSprite = styled.img`
  position: absolute;
  inset: 0;
  width: 500px;
  min-width: 500px;
  height: 200px;
  user-select: none;
`;

const GradientFade = styled.div`
  position: absolute;
  inset: 0;
  background: linear-gradient(
    to right,
    var(--color-background),
    transparent 20% 80%,
    var(--color-background)
  );
  pointer-events: none;
`;

export default ObjectPositionDemo;
